import React, { Component } from 'react'
import { connect } from 'react-redux'

import moment from 'moment/moment'
import 'url-search-params-polyfill'

// GA events handler
import triggerCustomGaEvent from '../../utilities/analytics/triggerCustomGaEvent'

import BkFlowEditPropertyField from './property/BkFlowEditPropertyField'
import BkFlowEditDatesField from './dates/BkFlowEditDatesField'
import BkFlowEditGuestContain from './guest/BkFlowEditGuestContain'
import BkFlowEditRatesAccordion from './rates/BkFlowEditRatesAccordion'
import BkFlowEditAccessibleField from './accessible/BkFlowEditAccessibleField'
import BkFlowMaterialLoader from '../elements/BkFlowMaterialLoader'

import setEditStayProperty from '../../actions/setEditStayProperty'
import fetchPropertyAvailability from '../../actions/fetchPropertyAvailability'
import validateSpecialCode from '../../actions/validateSpecialCode'

import yn from 'yn'
import _, {isEmpty} from 'lodash'

import '../../styles/css/components/edit/bk-flow-edit-stay.css'

class BkFlowEditStay extends Component {
	constructor(props) {
		super(props)
		const { urlData } = props

		const startDate = urlData.startDate ? moment(urlData.startDate) : moment()
		const endDate = urlData.endDate ? moment(urlData.endDate) : startDate.clone().add(1, 'day')

		const baseStartDate = moment(urlData.startDate).startOf('month').format('YYYY-MM-DD')
		const baseEndDate = moment(urlData.startDate).endOf('month').format('YYYY-MM-DD')

		this.state = {
			hotelCode: '',
			startDate,
			endDate,
			ratesExpanded: false,
			accessibleChecked: false,
			currentPromoCode: '',
			currentRateCode: '',
			hotelProvider: 0,
			hotelTheme: '',
			calendarAvailStart: baseStartDate,
			calendarAvailEnd: baseEndDate,
			specialCodeQueried: ''
		}
	}

	componentDidMount(){
		const {
			configData,
			urlData,
			handleFetchPropertyAvailability,
			handleUpdateProperty
		} = this.props

		const initialProperty = _.get(configData, 'hotel.options.properties[0]')
		const initialPropertyHotelCode = _.get(initialProperty, 'hotelCode')

		if (urlData.promoCode) {
			this.setState({ currentPromoCode: urlData.promoCode })
		}

		if (urlData.ratePlanCode) {
			this.setState({ currentRateCode: urlData.ratePlanCode })
		}

		if (urlData.accessible === 'true') {
			this.setState({ accessibleChecked: true })
		}

		if (urlData.hotelCode) {
			this.setState({ hotelCode: urlData.hotelCode })
			handleUpdateProperty(urlData.hotelCode)
		} else if (initialPropertyHotelCode) {
			this.setState({
				hotelCode: initialPropertyHotelCode,
				hotelTheme: _.get(initialProperty, 'theme')
			})
			handleUpdateProperty(initialPropertyHotelCode)
		}

		if (urlData.hotelProvider) {
			this.setState({ hotelProvider: urlData.hotelProvider })
		} else if (initialProperty) {
			this.setState({ hotelProvider:_.get(initialProperty, 'provider') })
		}

		// Initialize and configure hotelAvail calendar data
		if (
			yn(process.env.REACT_APP_COMPONENT_EDIT_STAY_PROPERTY_AVAILABILITY) &&
			(urlData.hotelCode || initialPropertyHotelCode)
		) {
			let roomTypeCode = ''

			// Set dynamic roomTypeCode
			if (urlData.roomTypeCode) {
				roomTypeCode = urlData.roomTypeCode
			}

			// get initial availability for room if feature enabled
			handleFetchPropertyAvailability(
				this.state.calendarAvailStart,
				this.state.calendarAvailEnd,
				urlData.hotelCode || initialPropertyHotelCode,
				roomTypeCode
			)
		}
	}

	// BkFlowEditPropertyField property change
	handlePropertySelect = (e) => {
		const {
			handleUpdateProperty,
			handleFetchPropertyAvailability,
			urlData
		} = this.props

		this.setState({ hotelCode: e.target.value })
		handleUpdateProperty(e.target.value)

		// Set hotelProvider VIA IPS Config or fallback to default
		if (e.target[e.target.selectedIndex].getAttribute('data-provider')) {
			this.setState({
				hotelProvider: e.target[e.target.selectedIndex].getAttribute('data-provider')
			})
		} else {
			this.setState({ hotelProvider: 0 })
		}

		// Set theme VIA IPS Config
		if (e.target[e.target.selectedIndex].getAttribute('data-theme')) {
			this.setState({
				hotelTheme: e.target[e.target.selectedIndex].getAttribute('data-theme')
			})
		}

		if (yn(process.env.REACT_APP_COMPONENT_EDIT_STAY_PROPERTY_AVAILABILITY)) {
			const arrivalMonthStart = moment(this.state.startDate).startOf('month').format('YYYY-MM-DD')
			const arrivalMonthEnd = moment(this.state.startDate).endOf('month').format('YYYY-MM-DD')

			const hotelCode = e.target.value
			let roomTypeCode = ''

			// Set dynamic roomTypeCode
			if (urlData.roomTypeCode) {
				roomTypeCode = urlData.roomTypeCode
			}

			handleFetchPropertyAvailability(
				arrivalMonthStart,
				arrivalMonthEnd,
				hotelCode,
				roomTypeCode
			)
		}
	}

	onDatesChange = ({ startDate, endDate }) => {
		if (endDate === null) {
			let updatedEnd = moment(startDate).add(1, 'days')
			this.setState({ startDate, updatedEnd })
		} else {
			this.setState({ startDate, endDate })
		}
	}

	handlePromoCode = (e) => {
		this.setState({ currentPromoCode: e })
	}

	handleRateCode = (e) => {
		this.setState({ currentRateCode: e })
	}

	handleToggleRates() {
		this.setState({ ratesExpanded: !this.state.ratesExpanded })
	}

	handleToggleAccessible = (currentAccessibility) => {
		this.setState({ accessibleChecked: !currentAccessibility })
	}

	handleUpdateCalendarDateRange = (updatedStartDate, updatedEndDate, hotelCode) => {
		const {
			handleFetchPropertyAvailability,
			urlData
		} = this.props

		this.setState({
			calendarAvailStart: updatedStartDate,
			calendarAvailEnd: updatedEndDate,
		})

		// Initialize and configure hotelAvail calendar data
		if (
			yn(process.env.REACT_APP_COMPONENT_EDIT_STAY_PROPERTY_AVAILABILITY) &&
			this.state.hotelCode
		) {
			let currentHotelCode = this.state.hotelCode

			if (hotelCode) {
				currentHotelCode = hotelCode
			}

			let roomTypeCode = ''

			// Set dynamic roomTypeCode
			if (urlData.roomTypeCode) {
				roomTypeCode = urlData.roomTypeCode
			}

			handleFetchPropertyAvailability(
				updatedStartDate,
				updatedEndDate,
				currentHotelCode,
				roomTypeCode
			)
		}
	}

	handleSubmitSpecialCode() {
		const { handleValidateSpecialCode } = this.props

		const rateQuery = {
			hotelCode: this.state.hotelCode,
			hotelProvider: this.state.hotelProvider,
			startDate: this.state.startDate,
			endDate: this.state.endDate,
			promoCode: this.state.currentPromoCode,
		}

		this.setState({
			specialCodeQueried: this.state.currentPromoCode
		})

		handleValidateSpecialCode(rateQuery)
	}

	// Handle updating query params and redirect
	submitEditStay() {
		const {
			configData,
			editStayGuestData
		} = this.props

		let configProperty = null

		const stayParams = new URLSearchParams(window.location.search)
		const numRoomsVal = String(Object.keys(editStayGuestData).length)

		if (
			!_.isEmpty(configData) &&
			this.state.hotelCode
		) {
			const configProperties = configData.hotel.options.properties
			const currentProperty = this.state.hotelCode

			// Match activeHotelCode to config properties array
			configProperty = configProperties.find(function (property) {
				return String(property.hotelCode) === String(currentProperty)
			})
		}

		if (
			configProperty &&
			configProperty.defaultCurrency
		) {
			if (stayParams.has('currency')) {
				stayParams.set('currency', configProperty.defaultCurrency)
			} else {
				stayParams.set('currency', configProperty.defaultCurrency)
			}
		}

		// Update query-params to scope of new reservation search
		if (this.state.hotelCode) {
			stayParams.set('hotelCode', this.state.hotelCode)
		}

		if (this.state.startDate && this.state.endDate) {
			stayParams.set('startDate', moment(this.state.startDate).format('YYYY-MM-DD'))
			stayParams.set('endDate', moment(this.state.endDate).format('YYYY-MM-DD'))
		}

		if (stayParams.has('promoCode') && this.state.currentPromoCode) {
			stayParams.set('promoCode', this.state.currentPromoCode.toUpperCase())
		} else if (this.state.currentPromoCode) {
			stayParams.set('promoCode', this.state.currentPromoCode.toUpperCase())
		} else if (this.state.currentPromoCode === '') {
			stayParams.delete('promoCode')
		}

		if (stayParams.has('ratePlanCode') && this.state.currentRateCode) {
			stayParams.set('ratePlanCode', this.state.currentRateCode.toUpperCase())
		} else if (this.state.currentRateCode) {
			stayParams.set('ratePlanCode', this.state.currentRateCode.toUpperCase())
		} else if (this.state.currentRateCode === '') {
			stayParams.delete('ratePlanCode')
		}

		if (this.state.accessibleChecked) {
			stayParams.set('accessible', 'true')
		} else if (!this.state.accessibleChecked) {
			stayParams.delete('accessible')
		}

		if (stayParams.has('numRooms') && numRoomsVal) {
			stayParams.set('numRooms', numRoomsVal)
		}
		// add adult and child params for multiple rooms
		if (!isEmpty(editStayGuestData)) {
			let index = 0;
			for (let room in editStayGuestData) {
					let adultNum = editStayGuestData[room].adults
					let childNum = editStayGuestData[room].children
				if (adultNum !== 0) {
					if (index === 0) {
						stayParams.set(`adults`, adultNum)
					} else {
						stayParams.set(`adults${index}`, adultNum)
					}
				}
				if (childNum !== 0) {
					if (index === 0) {
						stayParams.set(`children`, childNum)
					} else {
						stayParams.set(`children${index}`, childNum)
					}
				}
				index++
			}
		}

		if (this.state.hotelProvider) {
			stayParams.set('hotelProvider', this.state.hotelProvider)
		}

		if (this.state.hotelTheme) {
			stayParams.set('theme', this.state.hotelTheme)
		}

		localStorage.setItem('flowGuestData', JSON.stringify(editStayGuestData))

		// Dispatch initial GA events
		let reservationSearchData = {
			previousParameters: window.location.search,
			updatedParameters: stayParams.toString()
		}

		triggerCustomGaEvent('updateReservationSearch', reservationSearchData)

		// Reload window with updated query-parameters and localStorage
		window.location.href = '/book?' + stayParams.toString()
	}

	render() {
		const {
			configData,
			closeEditModal,
			specialCodeAvailability,
			specialCodeLoading,
			specialCodeError
		} = this.props

		const hotelLabels = configData.hotel.labels[0]

		let flowQueryConfig = null

		if (localStorage.flowQueryConfig) {
			flowQueryConfig = JSON.parse(localStorage.flowQueryConfig)
		}

		const specialCodeRoomTypes = _.get(specialCodeAvailability, '[0].roomStays[0].roomTypes', [])

		let isSpecialCodeAvailable = false

		if (!_.isEmpty(specialCodeRoomTypes) && String(this.state.currentPromoCode) === String(this.state.specialCodeQueried)) {
			isSpecialCodeAvailable = true
		} else if (String(this.state.currentPromoCode) !== String(this.state.specialCodeQueried)) {
			isSpecialCodeAvailable = false
		}

		return (
			<div className="bk-flow-edit-stay">
				<div className="u-modal__header">
					<h5>{ hotelLabels.editStay ? hotelLabels.editStay : 'Edit Stay' }</h5>
					<div
						className="u-modal__close u-font-small u-font-bold"
						onClick={ () => closeEditModal() }
					>
						{ hotelLabels.close ? hotelLabels.close : 'Close' }
						<i className="material-icons">close</i>
					</div>
				</div>

				<div className="u-modal__body">
					{ yn(process.env.REACT_APP_COMPONENT_EDIT_STAY_PROPERTY) &&
						<BkFlowEditPropertyField
							hotelCode={ this.state.hotelCode }
							handlePropertySelect={this.handlePropertySelect}
						/>
					}

					<BkFlowEditDatesField
						calendarAvailabilityEvent={this.handleUpdateCalendarDateRange}
						calendarAvailEnd={this.state.calendarAvailEnd}
						calendarAvailStart={this.state.calendarAvailStart}
						endDate={ this.state.endDate }
						hotelCode={ this.state.hotelCode }
						onDatesChange={ this.onDatesChange }
						startDate={ this.state.startDate }
					/>

					<BkFlowEditGuestContain />

					{ flowQueryConfig &&
					  (flowQueryConfig.enablePromoCode || flowQueryConfig.enableRateGroupCode) &&
						<div className={yn(process.env.REACT_APP_COMPONENT_EDIT_STAY_ACCESSIBILITY) ?
							'bk-flow-edit-stay__rates u-remove-margin'
							:
							'bk-flow-edit-stay__rates'
						}>
							<BkFlowEditRatesAccordion
								ratesExpanded={this.state.ratesExpanded}
								currentPromoCode={this.state.currentPromoCode}
								handlePromoCode={this.handlePromoCode}
								currentRateCode={this.state.currentRateCode}
								handleRateCode={this.handleRateCode}
								hotelLabels={hotelLabels}
								specialCodeError={specialCodeError}
								specialCodeRoomTypes={specialCodeRoomTypes}
								isSpecialCodeAvailable={isSpecialCodeAvailable}
							/>
							<button
								className="btn btn-text-only"
								onClick={() => this.handleToggleRates()}
							>
								{hotelLabels.specialCodeMessage ? hotelLabels.specialCodeMessage : 'I have a special code'}
								{this.state.ratesExpanded ? ' -' : ' +'}
							</button>
						</div>
					}

					{ yn(process.env.REACT_APP_COMPONENT_EDIT_STAY_ACCESSIBILITY) &&
						<BkFlowEditAccessibleField
							currentAccessibility={this.state.accessibleChecked}
							handleToggleAccessible={this.handleToggleAccessible}
							hotelLabels={hotelLabels}
						/>
					}

					<div className="bk-flow-edit-stay__update">
						{ yn(process.env.REACT_APP_COMPONENT_EDIT_STAY_PROMO_CODE_AVAILABILITY) &&
							!_.isEmpty(this.state.currentPromoCode) &&
							this.state.currentPromoCode !== this.state.specialCodeQueried &&
							!specialCodeLoading &&
							!isSpecialCodeAvailable ?
								<button
									className="btn btn-primary"
									onClick={ () => this.handleSubmitSpecialCode() }
								>
									{ hotelLabels.validate ? hotelLabels.validate : 'Validate Code' }
								</button>
						: yn(process.env.REACT_APP_COMPONENT_EDIT_STAY_PROMO_CODE_AVAILABILITY) &&
							!specialCodeLoading &&
							specialCodeError ?
								<button
									className="btn btn-primary"
									onClick={ () => this.handleSubmitSpecialCode() }
								>
									{ hotelLabels.validate ? hotelLabels.validate : 'Validate Code' }
								</button>
						: yn(process.env.REACT_APP_COMPONENT_EDIT_STAY_PROMO_CODE_AVAILABILITY) &&
							specialCodeLoading ?
								<BkFlowMaterialLoader
									parentClasses='bk-flow-edit-stay__special-code-loader u-txt-center'
									color={'#000'}
									size={25}
								/>
						: yn(process.env.REACT_APP_COMPONENT_EDIT_STAY_PROMO_CODE_AVAILABILITY) &&
							!_.isEmpty(specialCodeRoomTypes) && !specialCodeLoading && !specialCodeError ?
							<button
								className="btn btn-primary"
								onClick={ () => this.submitEditStay() }
							>
								{ hotelLabels.updateSearch ? hotelLabels.updateSearch : 'Update Search' }
							</button>
						:
							<button
								className="btn btn-primary"
								onClick={ () => this.submitEditStay() }
							>
								{ hotelLabels.updateSearch ? hotelLabels.updateSearch : 'Update Search' }
							</button>
						}
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => ({
	configData: state.configData.configuration,
	urlData: state.availabilityData.urlData,
	editStayGuestData: state.editStayGuestData,
	specialCodeAvailability: state.specialCodeAvailability.availability,
	specialCodeLoading: state.specialCodeAvailability.loading,
	specialCodeError: state.specialCodeAvailability.error
})

const mapDispatchToProps = dispatch => ({
	handleUpdateProperty(hotelCode) {
		return dispatch(setEditStayProperty(hotelCode))
	},
	handleFetchPropertyAvailability(startDate, endDate, hotelCode, roomTypeCode) {
		return dispatch(fetchPropertyAvailability(startDate, endDate, hotelCode, roomTypeCode))
	},
	handleValidateSpecialCode(rateQuery) {
		return dispatch(validateSpecialCode(rateQuery))
	}
})

export default connect(mapStateToProps, mapDispatchToProps)(BkFlowEditStay)



// WEBPACK FOOTER //
// ./src/components/edit/BkFlowEditStay.js